import { render, staticRenderFns } from "./AdminFunction.vue?vue&type=template&id=7d869791&scoped=true"
import script from "./AdminFunction.vue?vue&type=script&lang=js"
export * from "./AdminFunction.vue?vue&type=script&lang=js"
import style0 from "./AdminFunction.vue?vue&type=style&index=0&id=7d869791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d869791",
  null
  
)

export default component.exports